/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    object, func, number, array, string, shape, bool, arrayOf,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import IconClose from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import ReactMarkdown from 'react-markdown';
import AddonItem from './AddonItem';
import SelectedAddonsContainer from '../SelectedAddonsContainer';
import DesktopMobile from '../../../../../../../helpers/DesktopMobile/DesktopMobile';
import AddonsVerification from '../../../CommonProductAgeZipVerify/CommonProductAgeZipVerify';
import GraphqlWineRestrictions from '../../../CommonProductAgeZipVerify/partials/GraphqlWineRestrictions';
import GraphqlWineCompliance from '../GraphqlWineCompliance';
import { getFeatureFlags } from '../../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import {
    resetWineData,
} from '../../../../../../../../state/ducks/App/App-Actions';
import {
    getWineData,
} from '../../../../../../../../state/ducks/App/App-Selectors';
import { addToCartDataType } from '../../../common/types';

const styles = (theme) => ({
    wine: {
        width: 'auto',
        position: 'relative',
    },
    product: {
        display: 'flex',
        flexDirection: 'row',
    },
    headingSpacing: {
        marginTop: 15,
        marginBottom: 5,
    },
    headingSpacingMobile: {
        margin: 0,
    },
    productContainer: {
        border: `2px solid ${theme.palette.modalBorder || '#ececec'}`,
        borderRadius: 5,
        marginLeft: 10,
        minHeight: '50%',
        textAlign: 'center',
        '& > img': {
            width: '100%',
            height: '100%',
        },
    },
    shortDescription: {
        border: `2px solid ${theme.palette.modalBorder}`,
        borderRadius: 5,
        minHeight: '31%',
        maxHeight: 95,
        overflowY: 'auto',
        margin: '10px 0 0 10px',
        padding: '10px 10px 10px 15px',
        '& ul': {
            margin: 0,
            paddingLeft: 10,
        },

    },
    link: {
        background: 'none',
        border: 'none',
        textDecoration: 'underline',
        cursor: 'pointer',
        '&:focus': {
            outline: 'none',
        },
    },
    tastingLink: {
        padding: '10px',
    },
    testingContainer: {
        overflowX: 'hidden',
    },
    wineContainer: {
        border: theme.palette.modalBorder ? `1px solid ${theme.palette.modalBorder}` : '',
        minHeight: '415px',
        overflowX: 'hidden',
        margin: '0px 15px',
    },
    wineContainerMobile: {
        border: theme.palette.modalBorder ? `1px solid ${theme.palette.modalBorder}` : '',
        minHeight: '8rem',
        margin: 0,
    },
    additionalCompliance: {
        [theme.breakpoints.down(601)]: {
            marginBottom: '60px',
        },
        borderTop: theme.palette.modalBorder ? `1px solid ${theme.palette.modalBorder}` : '',
        marginTop: '10px',
        padding: '0 .75rem',
    },
    select: {
        backgroundColor: theme.palette.select,
        height: '38px',
        color: theme.palette.white,
    },
    selectMobile: {
        backgroundColor: theme.palette.select,
        color: theme.palette.white,
    },
    addonItemsTitle: {
        marginLeft: 25,
        fontWeight: 600,
        fontSize: 16,
        position: 'relative',
    },
    imageTitle: {
        fontWeight: 600,
        fontSize: 16,
        marginLeft: 10,
    },
    cancelButton: {
        color: theme.palette.white,
        backgroundColor: theme.typography.cms?.addonCancelButton || '#333333 !important',
        fontFamily: theme.typography.fontFamily,
        boxSizing: 'border-box',
        marginRight: 10,
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        fontWeight: '700',
        width: '240px',
        height: '50px',
        fontSize: '1em',
        textTransform: 'uppercase',
        borderRadius: '28px',
        lineHeight: '1.46em',
        margin: '15px 0px 0px 0px',
        float: 'right',
    },
    modalCloseButton: {
        right: '15px',
        position: 'absolute',
    },
    dialogContent: {
        padding: 0,
        '&:first-child': {
            padding: 0,
        },
    },
    selectionMessage: {
        color: theme.typography.cms?.addonSelectionMessageColor || '#039535',
        float: 'right',
        marginRight: 15,
        fontWeight: 100,
    },
    zipCodeInput: {
        width: '100%',
        display: 'block',  // IE 11
        '& > div': {
            width: '100%', // IE 11
        },
    },
    zipCodeInputValid: {
        '&::after': {
            position: 'absolute',
            zIndex: '999',
            backgroundColor: theme.palette.colorValid,
            color: theme.palette.cms?.white || '#ffffff',
            textAlign: 'center',
            content: '"✓"',
            margin: '-37px 0px 0px 80px',
            fontSize: '18px',
            padding: '5px',
            fontWeight: 'bold',
            lineHeight: '17px',
            width: '30px',
            height: '30px',
            borderRadius: '50%',
            animation: 'fadeZoomIn 0.3s ease-in',
            display: 'inline-block', // IE 11
        },
    },
    zipCodeInputInvalidIcon: {
        '&::after': {
            position: 'absolute',
            zIndex: '999',
            backgroundColor: theme.palette.cms?.errorZipVerifyPDP,
            color: theme.palette.white,
            textAlign: 'center',
            content: '"X"',
            fontSize: '17px',
            padding: '5px',
            fontWeight: 'bold',
            margin: '-37px 0px 0px 80px',
            lineHeight: '17px',
            width: '30px',
            height: '30px',
            borderRadius: '50%',
            animation: 'fadeZoomIn 0.3s ease-in',
            display: 'inline-block', // IE 11
        },
    },
    zipInputTextValid: {
        position: 'relative',
        '&::before': {
            position: 'absolute',
            zIndex: '999',
            color: theme.palette.cms?.colorValid || '#24b200',
            lineHeight: '25px',
            fontSize: '14px',
            fontWeight: '400',
            content: '"Wine can be shipped to this ZIP code"',
            border: 'none',
            transition: 'opacity 0.3s ease-in',
            opacity: 1,
            bottom: '-28px',
            margin: 0,
            width: '265px',
        },
    },
    zipCodeInputInvalid: {
        position: 'relative',
        '&::before': {
            position: 'absolute',
            zIndex: '999',
            color: theme.palette.cms?.errorZipVerifyPDP || '#79000f',
            lineHeight: '25px',
            fontSize: '14px',
            fontWeight: '400',
            content: '"Not eligible for Wine shipment"',
            bottom: '-10px',
            left: 0,
            width: '250px',
            height: '25px',
            transition: 'opacity 0.3s ease-in',
            opacity: 1,
            padding: 'inherit',
        },
    },
    ageInput: {
        width: '100%',
        display: 'flex',  // IE 11
        padding: '8px 0px 8px 0px',
        '& > div': {
            width: '100%', // IE 11
        },
    },
    ageInputInvalid: {
        position: 'relative',
        '&::before': {
            position: 'absolute',
            zIndex: '999',
            color: theme.palette.cms?.errorZipVerifyPDP,
            lineHeight: '18px',
            fontSize: '12px',
            border: 'none',
            fontWeight: '200',
            content: '"You must be 21 or older to purchase wine!"',
            height: '22px',
            transition: 'opacity 0.3s ease-in',
            opacity: 1,
            margin: '5px 0 0 16px',
        },
    },
    ageInputInvalidIcon: {
        '&::after': {
            position: 'absolute',
            zIndex: '999',
            margin: '-25px 0px 0px 205px',
            backgroundColor: theme.palette.cms?.errorZipVerifyPDP,
            color: theme.palette.white,
            textAlign: 'center',
            content: '\'\\2715\'',
            fontSize: '20px',
            padding: '3px',
            fontWeight: 'bold',
            lineHeight: '17px',
            left: '7px',
            width: '25px',
            height: '25px',
            borderRadius: '50%',
            animation: 'fadeZoomIn 0.3s ease-in',
            display: 'inline-block', // IE 11
        },
    },
    grid: {
        width: '250px',
        height: '90px',
    },
    ageInputTextValid: {
        position: 'relative',
        '&::before': {
            position: 'absolute',
            zIndex: '999',
            color: theme.palette.colorValid,
            lineHeight: '8px',
            fontSize: '14px',
            fontWeight: '400',
            content: '"Age Confirmed"',
            width: '108px',
            marginLeft: '16px',
            border: 'none',
            transition: 'opacity 0.3s ease-in',
            opacity: 1,
        },
    },
    ageInputValid: {
        '&::after': {
            position: 'absolute',
            zIndex: '999',
            backgroundColor: theme.palette.colorValid,
            color: theme.palette.white,
            textAlign: 'center',
            content: '"✓"',
            margin: '-26px 0px 0px 215px',
            fontSize: '20px',
            padding: '7px',
            fontWeight: 'bold',
            lineHeight: '17px',
            width: '30px',
            height: '30px',
            borderRadius: '50%',
            animation: 'fadeZoomIn 0.3s ease-in',
            display: 'inline-block', // IE 11
        },
    },
    limitErrorMessage: {
        color: theme.palette.cms?.errorZipVerifyPDP || '#a1001a',
        fontWeight: 100,
        position: 'absolute',
        top: '-20px',
    },
    headerModalSticky: {
        position: 'fixed',
        backgroundColor: theme.palette.white,
        borderBottom: `1px solid ${theme.palette.modalBorder}`,
        right: 0,
        top: 0,
        padding: '5px 0',
        zIndex: 9,
        left: 0,
        lineHeight: 1,
    },
    headerModalStickyBox: {
        display: 'flex',
    },
    titleModal: {
        flex: '2 0 0',
        color: theme.palette.colorIconHeader,
        fontSize: '16px',
        lineHeight: '1.8em',
        fontWeight: '600',
        fontFamily: theme.typography.secondaryFontFamily,
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        margin: '0',
        padding: '0 10px',
    },
    icon: {
        color: theme.palette.colorIconHeader,
        marginRight: 10,
    },
    headerSelectedMobile: {
        fontSize: 12,
        padding: '0 15px',
        display: 'flex',
        justifyContent: 'space-between',
    },
    itemSelectedMessage: {
        textAlign: 'right',
        color: theme.typography.cms?.addonSelectionMessageColor || '#039535',
    },
    itemErrorMessage: {
        textAlign: 'left',
        color: theme.palette.cms?.errorZipVerifyPDP || '#a1001a',
    },
});
class AddonItemsBuilder extends Component {
    constructor(props) {
        super(props);
        const { selectedAddons } = props;
        this.state = {
            selectedAddons: [...selectedAddons],
            counter: 0,
            imageUrl: '',
            openDrawer: false,
            addOnItemSelected: null,
            shortDescription: '',
            limitError: false,
            showTastingDetails: false,
            triggerTastingRestrictionsModal: false,
        };
        this.handleDrawer = this.handleDrawer.bind(this);
        this.handleAddonChange = this.handleAddonChange.bind(this);
    }

    componentDidMount() {
        const { resetWineDataAll } = this.props;
        resetWineDataAll();
        this.setFirstAddonData();
    }

    /*
    * @description This will set the first item to show the on quick view
    */

    setFirstAddonData = () => {
        const { data } = this.props;
        const addon = data?.[0]?.addons?.[0];
        this.setState({
            imageUrl: `${addon?.image?.path}${addon?.image?.name}x.jpg`,
            shortDescription: addon?.shortDescription || '',
        });
    }

    /*
    * @description This will show the item quick view
    * @param {string} imgUrl
    * @param {string} shortDesc
    */

    handleImageUrl = (imgUrl, shortDesc) => {
        this.setState({
            imageUrl: imgUrl,
            shortDescription: shortDesc || '',
        });
    }

    /*
    * @description Handle increment/decrement the addon items from the modal and save/remove from selection list
    * @param {object} option
    * @param {string} type
    */

    handleAddonChange = (option, type = 'add') => {
        const { selectedAddons } = this.state;
        const {
            handleAddonChange, maxAllowedAddons, wineValidation, track, categoryPath, categoryName,
        } = this.props;
        if (type === 'add') { // checking limit
            const totalSelectedAddons = ((selectedAddons || []).map((addon) => addon.qty) || [0]).reduce((a, b) => a + b, 0);
            if (totalSelectedAddons >= maxAllowedAddons) {
                this.setState({
                    limitError: true,
                });
                return;
            }
        }
        const selectedAddon = option;
        const addons = selectedAddons || [];

        const findSelectedAddOn = addons?.findIndex((addon) => addon?.partNumber === option?.partNumber);

        if (findSelectedAddOn < 0 && type === 'add') {
            selectedAddon.qty = 1;
        }

        if (findSelectedAddOn >= 0) {
            if (type === 'add') {
                selectedAddon.qty = (addons[findSelectedAddOn].qty || 0) + 1;
            } else {
                selectedAddon.qty = (addons[findSelectedAddOn].qty || 0) - 1;
            }
        }

        if (selectedAddon?.ageVerifyFlag && wineValidation?.wineVerify) {
            selectedAddon.wineVerify = wineValidation.wineVerify;
        }

        if (selectedAddon) {
            if (type === 'add') {
                const alreadySelected = addons?.findIndex((addon) => addon?.partNumber === selectedAddon?.partNumber);
                if (alreadySelected >= 0) {
                    addons.splice(alreadySelected, 1);
                }
                addons.push(selectedAddon);

                this.setState({
                    selectedAddons: addons,
                });
                handleAddonChange(option, type);
                track({
                    eventName: 'add_product',
                    eventCategory: 'Shopping',
                    eventAction: 'Product AddOn Selected',
                    eventLabel: option.name,
                    products: [{
                        ...option,
                        categoryPath,
                        categoryName,
                    }],
                });
            } else {
                const decrementAddon = addons.findIndex((addon) => addon?.partNumber === option?.partNumber);
                if (decrementAddon >= 0 && addons[findSelectedAddOn].qty === 0) {
                    addons.splice(findSelectedAddOn, 1);
                }
                this.setState({
                    selectedAddons: addons,
                    limitError: false,
                });
                handleAddonChange(option, type);
            }
        }
    }

    /*
    * @description Remove the selected addon Item from slection list
    * @param {object} item
    */
    removeAddon = (item) => {
        const { selectedAddons } = this.state;
        const addons = selectedAddons || [];
        const findSelectedAddOn = addons.findIndex((addon) => addon?.partNumber === item?.partNumber);
        if (findSelectedAddOn >= 0) {
            addons.splice(findSelectedAddOn, 1);
        }
        this.setState({
            selectedAddons: addons,
            limitError: false,
        });
    }

    /*
    * @description get the avaiablity from wine verification data
    * @param {object} data
    */
    getAvailability = (data) => {
        let availability = false;
        if (!data) {
            return null;
        }
        const keys = Object.keys(data?.wineAvailability);
        keys.forEach((key) => {
            if (data?.wineAvailability[key]?.isProductAvailable) {
                availability = true;
            }
        });
        return availability;
    };

    /*
    * @description Sum of all selected addon Items and quantity
    */
    generateItemCounter = () => {
        const { selectedAddons } = this.state;
        const qtyArray = (selectedAddons || []).map((addon) => addon.qty);
        return (qtyArray || []).reduce((a, b) => a + b, 0);
    };

    /*
    * @description This will set flag which is using for indicating user about addon limit
    * @param {bool} flag
    */
    setAddonLimitError = (flag) => {
        this.setState({ limitError: flag });
    }

    buildImgPath = (path, name) => `${path + name}x.jpg`;

    /*
    * @description This will show/hide Age Verification modal and send selected addon to verification request
    * @param {object} addon
    * @param {bool} True/False
    */
    handleDrawer = (value, addOnItem = null) => {
        this.setState({ openDrawer: value, addOnItemSelected: addOnItem });
    };

    renderAddonHeader = () => {
        const { classes, maxAllowedAddons } = this.props;
        const { limitError } = this.state;
        return (
            <div className={classes.addonItemsTitle}>
                {limitError && <span className={classes.limitErrorMessage}>You can only select {maxAllowedAddons} items</span>}
                {`${'Select up to '}${maxAllowedAddons}${' add-ons (optional)'}`}
                <span className={classes.selectionMessage}>{this.generateItemCounter()} of {maxAllowedAddons} selected</span>
            </div>
        );
    }

    handleTastingModal = (flag) => {
        this.setState({ showTastingDetails: flag, triggerTastingRestrictionsModal: flag });
    };

    handleTastingRestrictionsModal = (flag) => {
        this.setState({ triggerTastingRestrictionsModal: flag });
    };

    render() {
        const {
            classes,
            data,
            brand,
            maxAllowedAddons,
            onCloseModal,
            product,
            skuData,
            product: {
                brandId,
                partNumber,
            },
            categoryId,
            subscription,
            subscriptionDetails,
            presentation_family,
            disableAddToCart,
            isAddToCartEnabled,
            categoryPath,
            categoryName,
            productSkus,
            updateWineStatus,
            deliveryData,
            wineValidation,
            handleMiniCartModalClick,
            isMobile,
            mobileAgeVerificationOpen,
            handleMobileAgeVerification,
            addToCartData,
            selectedSku,
            handleAddonAdd,
            mixMatch,
            featureFlags,
            selectedMixMatchComponent,
        } = this.props;
        const findAddons = data;
        const {
            imageUrl,
            counter,
            selectedAddons,
            openDrawer,
            addOnItemSelected,
            shortDescription,
            limitError,
            showTastingDetails,
            triggerTastingRestrictionsModal,
        } = this.state;
        const wineModelOnAction = featureFlags['is-inline-wine-verification-model-on-atc-enabled'] || false;

        return (
            <>
                <Grid container>
                    <Grid item sm={8} xs={12} className={classes.wine}>
                        <Grid container className={`${classes.product} ${classes.headingSpacing}`}>
                            <DesktopMobile
                                mobile={() => (
                                    <>
                                        {!isMobile ? (
                                            <>
                                                <Grid item sm={12} className={classes.heading}>
                                                    {this.renderAddonHeader()}
                                                </Grid>
                                            </>
                                        ) : (
                                            <div className={classes.headerModalSticky}>
                                                <div className={classes.headerModalStickyBox}>
                                                    <h2 className={classes.titleModal}>Make it extra special</h2>
                                                    <div
                                                        className={classes.iconHeader}
                                                        onClick={onCloseModal}
                                                        onKeyDown={() => { }}
                                                        role="button"
                                                        tabIndex={-1}
                                                    >
                                                        <IconClose className={classes.icon} />
                                                    </div>
                                                </div>
                                                <div className={classes.headerSelectedMobile}>
                                                    <span className={classes.itemErrorMessage}>
                                                        {limitError && `You can only select ${maxAllowedAddons} items`}
                                                    </span>
                                                    <span className={classes.itemSelectedMessage}>
                                                        {this.generateItemCounter()} / {maxAllowedAddons} Selected
                                                    </span>

                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}
                                desktop={() => (
                                    <>
                                        <Grid item sm={4}>
                                            <div className={classes.imageTitle}> Product Details</div>
                                        </Grid>
                                        <Grid item sm={8} className={classes.heading}>
                                            {this.renderAddonHeader()}
                                        </Grid>
                                    </>
                                )}
                            />

                        </Grid>
                        <Grid container className={classes.product}>
                            <DesktopMobile
                                mobile={() => (
                                    <>
                                        <Grid item sm={12}>
                                            {isMobile && (
                                                <SelectedAddonsContainer
                                                    handleMiniCartModalClick={handleMiniCartModalClick}
                                                    product={product}
                                                    skuData={skuData}
                                                    selectedAddons={selectedAddons}
                                                    removeAddon={this.removeAddon}
                                                    brandId={brandId}
                                                    partNumber={partNumber}
                                                    categoryId={categoryId}
                                                    subscription={subscription}
                                                    subscriptionDetails={subscriptionDetails}
                                                    presentation_family={presentation_family}
                                                    disableAddToCart={disableAddToCart}
                                                    isAddToCartEnabled={isAddToCartEnabled}
                                                    categoryPath={categoryPath}
                                                    categoryName={categoryName}
                                                    closeAddonModal={onCloseModal}
                                                    mobileAgeVerificationOpen={mobileAgeVerificationOpen}
                                                    handleMobileAgeVerification={handleMobileAgeVerification}
                                                    addToCartData={addToCartData}
                                                    isMobile={isMobile}
                                                    selectedSku={selectedSku}
                                                    handleAddonAdd={handleAddonAdd}
                                                    mixMatch={mixMatch}
                                                    selectedMixMatchComponent={selectedMixMatchComponent}
                                                    wineModelOnAction={wineModelOnAction}
                                                />
                                            )}
                                            <div className={isMobile ? classes.wineContainerMobile : classes.wineContainer}>
                                                <div className={isMobile ? classes.selectMobile :  classes.select}>
                                                    <AddonItem
                                                        isMobile={isMobile}
                                                        groups={findAddons}
                                                        hover={this.handleImageUrl}
                                                        counter={counter}
                                                        handleAddonChange={this.handleAddonChange}
                                                        maxAllowedAddons={maxAllowedAddons}
                                                        selectedAddons={selectedAddons}
                                                        drawer={this.handleDrawer}
                                                        wineValidation={wineValidation}
                                                        setLimitError={this.setAddonLimitError}
                                                    />
                                                </div>
                                            </div>
                                        </Grid>
                                    </>
                                )}
                                desktop={() => (
                                    <>
                                        <Grid item sm={4}>
                                            <div className={classes.productContainer}>
                                                <img src={imageUrl} alt="Addon item" />
                                                { featureFlags['tasting-notes-enabled']
                                                 && (
                                                     <button
                                                         type="button"
                                                         className={`${classes.link} ${classes.tastingLink}`}
                                                         data-testid="addon-item-tasting-notes"
                                                         onClick={() => {
                                                             this.handleTastingModal(true);
                                                         }}
                                                     >
                                                         Tasting Notes
                                                     </button>
                                                 )}
                                            </div>
                                            {shortDescription && (
                                                <div className={classes.shortDescription}>
                                                    <ReactMarkdown source={shortDescription} escapeHtml={false} />
                                                </div>
                                            )}
                                        </Grid>
                                        <Grid item sm={8}>
                                            <div className={classes.wineContainer}>
                                                <div className={classes.select}>
                                                    <AddonItem
                                                        groups={findAddons}
                                                        hover={this.handleImageUrl}
                                                        counter={counter}
                                                        handleAddonChange={this.handleAddonChange}
                                                        maxAllowedAddons={maxAllowedAddons}
                                                        selectedAddons={selectedAddons}
                                                        drawer={this.handleDrawer}
                                                        wineValidation={wineValidation}
                                                        setLimitError={this.setAddonLimitError}
                                                    />

                                                </div>
                                            </div>
                                        </Grid>
                                    </>
                                )}
                            />

                        </Grid>
                        {!isMobile && (
                            <>
                                <Button
                                    className={classes.cancelButton}
                                    variant="contained"
                                    onClick={onCloseModal}
                                >
                                    Cancel
                                </Button>
                            </>
                        )}

                    </Grid>
                    <Grid item sm={4} className={classes.wine}>
                        {!isMobile && (
                            <SelectedAddonsContainer
                                handleMiniCartModalClick={handleMiniCartModalClick}
                                product={product}
                                skuData={skuData}
                                selectedAddons={selectedAddons}
                                removeAddon={this.removeAddon}
                                brandId={brandId}
                                partNumber={partNumber}
                                categoryId={categoryId}
                                subscription={subscription}
                                subscriptionDetails={subscriptionDetails}
                                presentation_family={presentation_family}
                                disableAddToCart={disableAddToCart}
                                isAddToCartEnabled={isAddToCartEnabled}
                                categoryPath={categoryPath}
                                categoryName={categoryName}
                                closeAddonModal={onCloseModal}
                                selectedSku={selectedSku}
                                wineValidation={wineValidation}
                                handleAddonAdd={handleAddonAdd}
                                mixMatch={mixMatch}
                                selectedMixMatchComponent={selectedMixMatchComponent}
                                wineModelOnAction={wineModelOnAction}
                            />
                        )}
                    </Grid>
                </Grid>
                {!isMobile ? (
                    <>
                        {openDrawer
                            && (
                                <AddonsVerification
                                    oncloseDrawer={this.handleDrawer}
                                    classes={classes}
                                    updateWineStatus={updateWineStatus}
                                    selectedSku={addOnItemSelected}
                                    deliveryData={deliveryData}
                                    productSkus={productSkus}
                                    brand={brand}
                                    isAddonAvailable
                                    addItemAddon={this.handleAddonChange}
                                    featureFlags={featureFlags}
                                    addonWindow
                                />
                            )}
                    </>
                ) : (
                    <>
                        <AddonsVerification
                            forceModal={!wineModelOnAction}
                            hasAddons
                            oncloseDrawer={this.handleDrawer}
                            classes={classes}
                            updateWineStatus={updateWineStatus}
                            // Only trigger age verification if at least one addon requires
                            selectedSku={selectedAddons.find((addon) => addon.ageVerifyFlag === true || addon.ageVerifyFlag === 'true')}
                            deliveryData={deliveryData}
                            productSkus={productSkus}
                            brand={brand}
                            isMobile
                            isAddonAvailable={!wineModelOnAction}
                            addItemAddon={this.handleAddonChangeMobile}
                            mobileAgeVerificationOpen={mobileAgeVerificationOpen}
                            handleMobileAgeVerification={handleMobileAgeVerification}
                            addToCartData={addToCartData}
                            featureFlags={featureFlags}
                            addonWindow={!wineModelOnAction}
                        />
                    </>
                )}
                <div className={classes.additionalCompliance} data-testid="addon-item-additional-compliance">
                    <GraphqlWineCompliance brand={brand} handleTastingRestrictionsModal={this.handleTastingRestrictionsModal} />
                </div>
                <Dialog
                    PaperProps={{
                        className: classes.addonsVerification,
                    }}
                    open={triggerTastingRestrictionsModal}
                    maxWidth="xs"
                    onClose={showTastingDetails ? () => { this.handleTastingModal(false); } : () => { this.handleTastingRestrictionsModal(false); }}
                >
                    <DialogContent data-testid="tasting-restrictions-modal-content" className={classes.dialogContent}>
                        <IconClose className={classes.modalCloseButton} data-testid="tasting-restrictions-modal-content-close" onClick={showTastingDetails ? () => { this.handleTastingModal(false); } : () => { this.handleTastingRestrictionsModal(false); }} />
                        {showTastingDetails ? (
                            <div className={classes.testingContainer} data-testid="tasting-notes-details">
                                <GraphqlWineRestrictions path="/h/view/tasting-notes" />
                            </div>
                        ) : (
                            <div className={classes.wineContainer} data-testid="wine-shipping-details">
                                <h4 className={classes.wineHeader}>WINE SHIPPING DETAILS</h4>
                                <GraphqlWineRestrictions path="/h/view/wineship" />
                            </div>
                        )}
                    </DialogContent>
                </Dialog>
            </>
        );
    }
}

AddonItemsBuilder.propTypes = {
    classes: object.isRequired,
    handleMiniCartModalClick: func.isRequired,
    data: arrayOf(shape({
        name: string.isRequired,
        maxAllowedAddons: number.isRequired,
        addons: arrayOf(shape({
            id: string.isRequired,
            shortDescription: string,
            name: string.isRequired,
        })),
    })).isRequired,
    brand: shape({
        domain: string,
    }).isRequired,
    maxAllowedAddons: number.isRequired,
    onCloseModal: func,
    skuData: arrayOf(
        shape({
            id: string.isRequired,
            name: string.isRequired,
            prices: arrayOf(
                shape({
                    type: string.isRequired,
                    value: number.isRequired,
                }),
            ).isRequired,
        }),
    ).isRequired,
    product: shape({
        id: string.isRequired,
        name: string.isRequired,
        brandId: string.isRequired,
        partNumber: string.isRequired,
    }).isRequired,
    handleAddonChange: func,

    categoryId: string,
    subscriptionDetails: shape({
        subscriptionType: string,
        subscriptionDuration: string,
        subscriptionFrequency: string,
    }),
    subscription: shape({
        subscriptionKey: array,
        subscriptionIndefinite: string,
        subscriptionType: array,
        implementProductSubscription: bool,
        viewSubscription: bool,
        isTypeDiscovery: bool,
    }),
    presentation_family: string.isRequired,
    disableAddToCart: bool,
    isAddToCartEnabled: bool,
    categoryPath: string,
    categoryName: string,
    productSkus: arrayOf(
        shape({
            minAge: string.isRequired,
        }).isRequired,
    ).isRequired,
    deliveryData: shape({
        location_type_options: arrayOf(
            shape({
                name: string,
                value: string,
            }),
        ),
        show: bool,
        title: string,
        zip_code_title: string,
        location_type_title: string,
    }),
    updateWineStatus: func,
    resetWineDataAll: func,
    wineValidation: shape({
        wineAvailability: object, // object type array
        wineVerify: shape({
            birthDay: 'string',
            birthMonth: 'string',
            birthYear: 'string',
            minAge: 'string',
        }),
    }),
    isMobile: bool,
    mobileAgeVerificationOpen: bool,
    handleMobileAgeVerification: func,
    addToCartData: addToCartDataType,
    selectedSku: shape({
        id: string.isRequired,
        minAge: string.isRequired,
    }).isRequired,
    track: func,
    handleAddonAdd: func,
    mixMatch: bool,
    selectedAddons: arrayOf(shape({
        id: string,
        ageVerifyFlag: bool,
        partNumber: string,
        name: string,
    })),
    featureFlags: object.isRequired,
    selectedMixMatchComponent: arrayOf(shape({
        brandCode: string,
        componentType: string,
        productId: string,
        productCode: string,
    })),
};

AddonItemsBuilder.defaultProps = {
    onCloseModal: () => {},
    handleAddonChange: () => {},
    isAddToCartEnabled: true,
    subscriptionDetails: {},
    disableAddToCart: false,
    subscription: {},
    resetWineDataAll: () => { },
    updateWineStatus: () => {},
    deliveryData: {},
    categoryId: '',
    categoryPath: '',
    categoryName: '',
    wineValidation: null,
    isMobile: false,
    mobileAgeVerificationOpen: false,
    handleMobileAgeVerification: () => { },
    addToCartData: {},
    track: () => {},
    handleAddonAdd: () => {},
    mixMatch: false,
    selectedAddons: [],
    selectedMixMatchComponent: [],
};

const mapDispatchToProps = (dispatch) => ({
    resetWineDataAll: bindActionCreators(resetWineData, dispatch),
});

const mapStateToProps = (state) => ({
    wineValidation: getWineData(state),
    featureFlags: getFeatureFlags(state),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles)(AddonItemsBuilder));
